import React from 'react';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';

interface ResetGroundfishProjectionData {
  /** Called when user clicks Reset to Default. Clears data and rebuilds database from 2015 to 2030. */
  onResetGroundfish?: () => void | Promise<void>;
  /** Disabled when updating/loading. */
  resetGroundfishDisabled?: boolean;
}

/**
 * Reset button for groundfish (WHAM) projection.
 * Resets to default values by clearing data and rebuilding the database.
 * Prefers PageDataContext.actions.refreshDatabase when available.
 */
export default function ResetGroundfishProjection(props: RegistryComponentProps): React.ReactElement {
  const pageData = usePageDataContextOptional();
  const data = getRegistryData<ResetGroundfishProjectionData>(props);
  const onReset = data.onResetGroundfish ?? (pageData?.actions?.refreshDatabase as (() => void | Promise<void>) | undefined);
  const disabled = data.resetGroundfishDisabled ?? (pageData?.data?.updatingPStar as boolean | undefined) ?? false;

  const handleClick = React.useCallback(() => {
    if (typeof onReset === 'function') {
      void Promise.resolve(onReset());
    }
  }, [onReset]);

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
      <button
        className="btn noscroll-refresh-database-button"
        onClick={handleClick}
        disabled={disabled}
      >
        Reset to Default
      </button>
    </div>
  );
}
